module.exports = __webpack_public_path__ + "img/event-slider-1.bee88c13.jpg";